import { useQueryWithUserId } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

/**
 * React query state key for fetch bid item condition api it can invalidate
 * the state of bid item condition
 */
const FETCH_BIDS_ITEM_CONDITION_QUERY_KEY =
  'fetch-bid-item-condition--query-key';

/**
 * React Query hook for bid ItemCondition it will call
 * `fetchBidItemCondition` and give error loading success state with response
 */
export const useBidItemConditionQuery = (assetId: string) => {
  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    queryKey: [FETCH_BIDS_ITEM_CONDITION_QUERY_KEY, assetId],
    queryFn: () => BIDS_API.fetchBidItemCondition(assetId),
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
};
